import { Expose } from 'class-transformer';

export class HourlyForecast {
  @Expose({ name: 'time' })
  time: string;

  @Expose({ name: 'temperature' })
  temperature: number;

  @Expose({ name: 'feels_temp' })
  feelsTemperature: number;

  @Expose({ name: 'icon_url' })
  icon: string;

  @Expose({ name: 'is_sunset_after' })
  isSunsetAfter: boolean;

  @Expose({ name: 'is_sunrise_after' })
  isSunriseAfter: boolean;

  @Expose()
  description: string;
}
